import { render, staticRenderFns } from "./FilterSummary.vue?vue&type=template&id=37ffa31e&scoped=true&"
import script from "./FilterSummary.vue?vue&type=script&lang=js&"
export * from "./FilterSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ffa31e",
  null
  
)

export default component.exports